import { BaseContext } from '../../../../utils/basecontext';
import { HttpClient } from '../../../../utils/httpclient/httpclient';
import { POST } from '../../api';
import { SixdeeCRBTAPI } from '../../sixdeecrbtapi';
import { SalatiToneDetailsRequest } from './salatitonedetailsrequest';

export class SalatiToneDetailsAPI extends SixdeeCRBTAPI<SalatiToneDetailsRequest>
{
    constructor(httpClient:HttpClient, appContext: BaseContext){
        super(httpClient, appContext);
    }

    getHttpMethod(){
        return POST;
    }

    getAPIURL(): string
    {
        // https://www.callertunes.etisalat.ae/Middleware/api/adapter/v1/crbt/get-salati-tone-details
        return "get-salati-tone-details";
    }

    getRequestData()
    {
        return "clientTxnId=21042020"+"&"+
               "channelId="+ this.getRequest().getSalatiToneDetailsRequest().getChannelId()+"&"+
               "serviceId=" + this.getRequest().getSalatiToneDetailsRequest().getServiceId() +"&"+
               "activityId="+ this.getRequest().getSalatiToneDetailsRequest().getActivityId() +"&"+
               "language="+ this.getRequest().getSalatiToneDetailsRequest().getLanguage();
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/salati/salatitonedetails/salatitonedetailsapi.tsx